import { queryK1PriceActivity } from "@/graphql/promotion.gql";
import { Module, Mutation, Action } from "vuex-module-decorators";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { queryRequest, handlePaginationData } from "@/utils/request";
import { RootState } from "@/store";
import type { PaginationDataState } from "@/types";

export interface IK1PromotionState extends PaginationDataState {
  listData: any[];
}

@Module({ name: "K1PromotionListModule", namespaced: true })
export default class K1PromotionListModule
  extends PaginationModule<IK1PromotionState, RootState>
  implements IK1PromotionState {
  public paginationData: any = {
    pageSize: 1000, // pageSize = 1000 => 接口暂无状态排序，需手动排序
    pageNum: 1,
    totalCount: 0
  };
  public listData: any[] = [];

  @Mutation
  saveListDataMutation(data = []) {
    this.listData = data;
  }
  @Mutation
  addListDataMutation(data = []) {
    this.listData.push(...data);
  }

  @Action
  async initListAction() {
    let {
      state: {
        paginationData: { pageNum }
      }
    } = this.context;
    const { data: list = [], totalCount = 0 } = handlePaginationData(
      await queryRequest({
        query: queryK1PriceActivity,
        variables: {
          input: { activityType: "" },
          pageInput: { pageSize: 1000, pageNum }
        }
      })
    );

    let {
      commit,
      state: { paginationData }
    } = this.context;
    commit(
      paginationData.pageNum === 1
        ? "saveListDataMutation"
        : "addListDataMutation",
      list
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }
}
